// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__kzIpZ","header":"ReportDetails_header__35ifU","title":"ReportDetails_title__3fb3g","left":"ReportDetails_left__1eOXR"};